import { RouteObject } from 'react-router-dom';
import { lazy } from 'react';

const Home = lazy(() => import('../pages/home/page'));
const Illustrators = lazy(() => import('../pages/illustrators/page'));
const Designers = lazy(() => import('../pages/designers/page'));
const Writers = lazy(() => import('../pages/writers/page'));
const Painters = lazy(() => import('../pages/painters/page'));
const ArtistDetail = lazy(() => import('../pages/artist/page'));
const About = lazy(() => import('../pages/about/page'));
const Contact = lazy(() => import('../pages/contact/page'));
const AdminLogin = lazy(() => import('../pages/admin/login/page'));
const AdminDashboard = lazy(() => import('../pages/admin/dashboard/page'));
const ArtistForm = lazy(() => import('../pages/admin/artist-form/page'));
const NotFound = lazy(() => import('../pages/NotFound'));

const routes: RouteObject[] = [
  {
    path: '/',
    element: <Home />,
  },
  {
    path: '/illustrators',
    element: <Illustrators />,
  },
  {
    path: '/designers',
    element: <Designers />,
  },
  {
    path: '/writers',
    element: <Writers />,
  },
  {
    path: '/painters',
    element: <Painters />,
  },
  {
    path: '/artist/:slug',
    element: <ArtistDetail />,
  },
  {
    path: '/about',
    element: <About />,
  },
  {
    path: '/contact',
    element: <Contact />,
  },
  {
    path: '/admin/login',
    element: <AdminLogin />,
  },
  {
    path: '/admin',
    element: <AdminDashboard />,
  },
  {
    path: '/admin/artist/new',
    element: <ArtistForm />,
  },
  {
    path: '/admin/artist/edit/:slug',
    element: <ArtistForm />,
  },
  {
    path: '*',
    element: <NotFound />,
  },
];

export default routes;
